import React from 'react'

export default (props) => 
    <svg {...props} width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.41406 1.34277L7.07092 6.99963L1.41406 12.6565" stroke="#0F2A2B" strokeWidth="2"/>
    </svg>
